import BadRequestHttpError from "../BadRequestHttpError";
import ITokenNotFoundHttpErrorResponse from "../../interfaces/BadRequest/ITokenNotFoundHttpErrorResponse";

export default class TokenNotFoundHttpError extends BadRequestHttpError<ITokenNotFoundHttpErrorResponse> {
    constructor(response: ITokenNotFoundHttpErrorResponse) {
        super("Token not found!", response);
    }
}
